module.exports = __webpack_public_path__ + "img/Icon_inventario_padres.d149a4a3.svg";